// Lazy-loads ApexCharts and Preline's chart helpers on demand, exposing them as
// `window.ApexCharts` / `window.buildChart` / `window.buildTooltip`.
//
// Charts live on only a handful of admin/analytics pages, so neither the ~556 KB
// ApexCharts library nor Preline's apexcharts helper (which statically bundles
// ApexCharts in v3) should ride in the every-page application bundle. Both are
// dynamically imported here into on-demand chunks. Call `await ensureApexCharts()`
// before invoking buildChart / new ApexCharts.
//
// Idempotent and concurrency-safe: the import promise is memoized, so multiple
// charts on one page share a single fetch + a single set of window assignments.
let pending = null

export function ensureApexCharts() {
  if (window.ApexCharts && window.buildChart) {
    return Promise.resolve({
      ApexCharts: window.ApexCharts,
      buildChart: window.buildChart,
      buildTooltip: window.buildTooltip
    })
  }

  pending ||= Promise.all([
    import("apexcharts"),
    import("preline/dist/helper-apexcharts.js")
  ]).then(([apex, helper]) => {
    // Preline's helper is a UMD; under a dynamic import its functions live on
    // `default`, not as named exports (a static import hoists them, a dynamic
    // one does not).
    const ApexCharts = apex.default
    const { buildChart, buildTooltip } = helper.default
    window.ApexCharts = ApexCharts
    window.buildChart = buildChart
    window.buildTooltip = buildTooltip
    return { ApexCharts, buildChart, buildTooltip }
  })

  return pending
}
